(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ReferenceModalController', ReferenceModal);

    ReferenceModal.$inject = ['CampaignService', 'pid', 'referenceId', 'close'];

    function ReferenceModal(CampaignService, pid, referenceId, close) {
        var vm = this;

        vm.referenceId = angular.copy(referenceId);

        vm.setReferenceId = function () {
            CampaignService.setReferenceId({
                'pid': pid,
                'referenceId': vm.referenceId
            });
            close(vm.referenceId, 500);
        };
    }
})();